import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Colors, FontSize, FontWeight, Radii } from '../../theme/tokens';
import { ScreenShell } from '../../components/WebShell';
import { Icon } from '../../components/Icon';

interface Props {
  kind?: string;
}

export function StubScreen({ kind }: Props) {
  return (
    <ScreenShell crumbs={[{ label: 'Settings' }, { label: kind || 'Coming soon' }]}>
      <View style={styles.root}>
        <View style={styles.card}>
          <View style={styles.iconWrap}>
            <Icon name="Bolt" size={28} color={Colors.ink4} />
          </View>
          <Text style={styles.title}>Coming soon</Text>
          {kind && (
            <Text style={styles.kind}>{kind}</Text>
          )}
          <Text style={styles.sub}>This screen is not yet implemented in this prototype.</Text>
        </View>
      </View>
    </ScreenShell>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1, justifyContent: 'center', alignItems: 'center',
    backgroundColor: Colors.paper,
  },
  card: {
    padding: 40, alignItems: 'center',
    backgroundColor: Colors.card,
    borderRadius: Radii.r4,
    borderWidth: 1, borderColor: Colors.line,
    maxWidth: 400, width: '90%' as any,
  },
  iconWrap: {
    width: 56, height: 56, borderRadius: Radii.r3,
    backgroundColor: Colors.paper3,
    justifyContent: 'center', alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 20, fontWeight: FontWeight.semibold,
    color: Colors.ink, marginBottom: 8,
  },
  kind: {
    fontSize: 12, fontWeight: FontWeight.medium,
    color: Colors.ink3, marginBottom: 6,
    backgroundColor: Colors.paper2,
    paddingHorizontal: 10, paddingVertical: 3,
    borderRadius: Radii.r2,
  },
  sub: {
    fontSize: 13, color: Colors.ink3, textAlign: 'center', marginTop: 4,
  },
});
